import React, { useState, useEffect } from 'react';
import { AnalysisForm, PreviousAnalyses, Features, Testimonials, Footer, Loader } from '../components';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  withCredentials: true
});

export function HomePage() {
  const [analyses, setAnalyses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAnalyses = async () => {
      try {
        const response = await api.get('/api/analyses');
        setAnalyses(response.data);
      } catch (err) {
        console.error('Failed to fetch analyses:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAnalyses();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <main className="container mx-auto px-4 pt-20 pb-32 md:pt-32">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-4xl md:text-8xl font-bold mb-6 text-white leading-tight tracking-tighter">
            AI Agent See
          </h1>
        </div>
        <AnalysisForm />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="mt-32 mb-32">
            <PreviousAnalyses analyses={analyses} />
            {analyses.length === 0 && <Features />}
          </div>
        )}
        <div className="mt-32 mb-32">
          <Testimonials />
        </div>
      </main>
      <Footer />
    </div>
  );
} 